<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="mask0_281_6733" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32">
<rect width="32" height="32"/>
</mask>
<g mask="url(#mask0_281_6733)">
<path d="M10.4333 17.3333L17.9 24.8L16 26.6666L5.33331 16L16 5.33331L17.9 7.19998L10.4333 14.6666H26.6666V17.3333H10.4333Z"/>
</g>
</svg>
